module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-sad.452eeb41.png";